import styled from 'styled-components';

export const Time = styled.time`
  display: inline-block;
  margin: 0;
  padding: 0;
`;
